import { AxiosError } from "axios";

import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";
import {
  AssetRequestType,
  AssetStatus,
} from "@/v1/components/pages/GameDetail/components/AssetsTab/utils/constants";
import { refetchAssetsQuery } from "@/v1/components/pages/GameDetail/utils/refetchAssetsQuery";
import { ErrorResponse } from "@/v1/types/global";

import { StateType } from "../useRequestsStore";

import { updateQueueAsset } from "./updateQueueAsset";

export type MakeAssetRequestType = (
  requestAsset: IAsset,
  actualRequest: () => Promise<any>,
  state: StateType,
  options?: {
    onEnd?: () => void;
    onError?: () => void;
  },
) => Promise<void>;

export const makeAssetRequest: MakeAssetRequestType = async (
  requestAsset,
  request,
  state,
  { onEnd, onError } = {},
) => {
  const { waitingQueue } = state;
  const requestStartAsset = { ...requestAsset, status: AssetStatus.IN_PROGRESS };
  updateQueueAsset(requestAsset, requestStartAsset, state);

  try {
    await request();
    updateQueueAsset(
      requestStartAsset,
      {
        ...requestStartAsset,
        status: AssetStatus.SUCCESS,
        requestPecentage: 100,
      },
      state,
    );
  } catch (error) {
    const errorResponse = (error &&
      typeof error === "object" &&
      (error as AxiosError<ErrorResponse>)?.response?.data) as ErrorResponse;
    const errorMessage = errorResponse?.errors
      ? errorResponse.errors.map(({ message }) => message).join(", ")
      : "";

    updateQueueAsset(
      requestStartAsset,
      {
        ...requestStartAsset,
        status: AssetStatus.ERROR,
        requestPecentage: 0,
        errorCode: errorResponse?.errors?.[0]?.code,
        errorMessage,
      },
      state,
    );

    if (onError) onError();
  } finally {
    const nextRequest = waitingQueue.shift();

    if (nextRequest) {
      const [asset, assetRequest, options] = nextRequest;
      await makeAssetRequest(asset, assetRequest, state, options);
    }

    if (requestStartAsset.requestType === AssetRequestType.UPLOAD) {
      await refetchAssetsQuery();
    }

    if (onEnd) onEnd();
  }
};
